import { Col, Row } from 'react-bootstrap';
import Notification from 'components/global/DashboardNotifications/Notification';

const DashboardNotifications = ({ data, onDismiss }) => (
  <>
    <h4 className="d-inline fw-600 text-primary">Notifications</h4>
    <p className="d-inline ms-8">({`${data?.length} new`})</p>
    {data?.length
      ? (
        <div
          id="notificationDiv"
          className="hide-scrollbar mt-8"
        >
          {data?.map((notification) => (
            <Row className="mt-16 mb-24" key={notification.id}>
              <Col>
                <Notification notification={notification} onDismiss={onDismiss} />
              </Col>
            </Row>
          ))}
        </div>
      )
      : (<p className="lead mt-24 mb-0">You&apos;re caught up!</p>)}
  </>
);

export default DashboardNotifications;
